"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const useErrorBoundaryStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: {
        width: '100%',
        height: '30%',
    },
    title: {
        padding: 0,
        marginLeft: theme.spacing(1),
    },
}));
const ErrorBoundaryMessage = ({ message }) => {
    const classes = useErrorBoundaryStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { className: classes.container, display: "flex", justifyContent: "center", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.ErrorOutlineIcon, {}), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "h5", className: classes.title, children: message || translate('error_in_component') })] }));
};
class ErrorBoundary extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        const { handleReactCatch } = this.props;
        handleReactCatch?.(error, info);
    }
    render() {
        const { props, state } = this;
        if (state.hasError) {
            return (0, jsx_runtime_1.jsx)(ErrorBoundaryMessage, { message: props.message });
        }
        return props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map